import { LightningElement, api } from "lwc";

export default class PrimitiveNav extends LightningElement {
  static shadowSupportMode = "any";
  @api links;
  @api direction = "inline";
}
